<template>
  <div>
    <!-- 复制标签类型-->
    <Modal v-model="modalShow" width="1200">
      <div slot="header">每日数据</div>
      <Row :gutter="18">
        <Col span="3">
          <Select
            v-model="dayData.params.query_type"
            placeholder="请选择类型"
            clearable
          >
            <Option
              v-for="(item, index) in select.Query_Type_day"
              :value="item.value"
              :label="item.name"
              :key="index"
            >
              {{ item.name }}
              <span style="color: #bbb">({{ item.value }})</span>
            </Option>
          </Select>
        </Col>
        <Col span="3">
<!--          <Select
            v-model="dayData.params.platid"
            placeholder="请选择代理"
            @on-change="updatePlatDay"
            clearable
          >
            <Option
              v-for="(item, index) in plat_list"
              :value="item.id"
              :label="item.name"
              :key="index"
            >
              {{ item.name }}
              <span style="color: #bbb">({{ item.id }})</span>
            </Option>
          </Select>-->
          <Select
            v-model="dayData.params.app_id"
            placeholder="请选择代理"
            @on-change="updatePlatDay"
            clearable
          >
            <Option
              v-for="(item, index) in getAppList()"
              :value="item.appid"
              :label="item.appName"
              :key="index"
            >
              {{ item.appName }}
              <span style="color: #bbb">({{ item.appid }})</span>
            </Option>
          </Select>
        </Col>
        <Col span="4">
          <Select
            v-model="dayData.params.general"
            filterable
            placeholder="请选择商户"
            :max-tag-count="3"
            @on-change="updateGeneralDay"
            clearable
          >
            <Option
              v-for="(item, index) in select.general_list"
              :value="item.general"
              :label="item.general_name"
              :key="index"
            >
              {{ item.general_name }}
              <span style="color: #bbb">({{ item.general }})</span>
            </Option>
          </Select>
        </Col>
        <Col span="4">
          <Select
            v-model="dayData.params.pack_no"
            filterable
            placeholder="请选择子商户"
            clearable
          >
            <Option
              v-for="(item, index) in getPackListDay()"
              :value="item.pack_no"
              :label="item.pack_name"
              :key="index"
            >
              {{ item.pack_name }}
              <span style="color: #bbb">({{ item.pack_no }})</span>
            </Option>
          </Select>
        </Col>
        <Col span="4">
          <Select
            v-model="dayData.params.game_id"
            filterable
            placeholder="请选择子游戏"
            clearable
          >
            <Option
              v-for="(item, index) in select.GameType_List"
              :value="item.value"
              :label="item.name"
              :key="index"
            >
              {{ item.name }}
              <span style="color: #bbb">({{ item.value }})</span>
            </Option>
          </Select>
        </Col>
        <Col span="4">
          <DatePicker
            type="daterange"
            v-model="dayData.params.dataTime"
            placeholder="筛选时间"
            :options="dateOptions"
            style="width: 100%"
          ></DatePicker>
        </Col>
        <Col span="2" style="display: flex; justify-content: space-between">
          <Button type="primary" @click.native="searchDataDay()">搜索</Button>
        </Col>
      </Row>
      <Table
        border
        :columns="dayData.columns"
        :data="dayData.data"
        style="margin-top: 12px"
        :max-height="340"
        ref="tableRef"
      ></Table>
    </Modal>
    <Card shadow>
      <Row :gutter="24">
        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">代理:</span>
            <Select
              v-model="table.params.app_id"
              filterable
              placeholder="筛选代理"
              :max-tag-count="3"
              @on-change="getAppGenList"
              clearable
            >
              <Option
                v-for="(item, index) in getAppList()"
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">商户:</span>
            <Select
              v-model="table.params.general_id"
              filterable
              placeholder="筛选 商户"
              :max-tag-count="3"
              @on-change="updateGeneral"
              clearable
              :disabled="table.params.query_type == 1"
            >
              <Option
                v-for="(item, index) in select.general_list"
                :value="item.general"
                :label="item.general_name"
                :key="index"
              >
                {{ item.general_name }}
                <span style="color: #bbb">({{ item.general }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 60px">子商户:</span>
            <Select
              v-model="table.params.pack_no"
              filterable
              placeholder="筛选 子商户"
              clearable
              :disabled="
                table.params.query_type == 1 || table.params.query_type == 2
              "
            >
              <Option
                v-for="(item, index) in getPackList()"
                :value="item.pack_no"
                :label="item.pack_name"
                :key="index"
              >
                {{ item.pack_name }}
                <span style="color: #bbb">({{ item.pack_no }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 60px">玩家ID:</span>
            <Input
              v-model="table.params.user_id"
              placeholder="搜索 玩家ID"
              clearable
              :disabled="
                table.params.query_type == 1 ||
                  table.params.query_type == 2 ||
                  table.params.query_type == 3
              "
            ></Input>
          </label>
        </Col>

      </Row>
      <Row :gutter="24" style="margin-top: 20px">
        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">三方账号:</span>
            <Input
              v-model="table.params.external_account"
              placeholder="三方账号"
              clearable
              :disabled="
                table.params.query_type == 1 ||
                  table.params.query_type == 2 ||
                  table.params.query_type == 3
              "
            ></Input>
          </label>
        </Col>
        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">类型:</span>
            <Select
              v-model="table.params.query_type"
              filterable
              placeholder="选择类型"
              clearable
              @on-change="queryTypeChange"
            >
              <Option
                v-for="item in select.Query_Type"
                :value="item.value"
                :label="item.name"
                :key="item.value"
              >
                {{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">上级ID:</span>
            <Input
              v-model="table.params.superior_id"
              placeholder="上级ID"
              clearable
              :disabled="table.params.query_type == 1"
            ></Input>
          </label>
        </Col>
        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">上级账号:</span>
            <Input
              v-model="table.params.superior_name"
              placeholder="上级账号"
              clearable
              :disabled="table.params.query_type == 1"
            ></Input>
          </label>
        </Col>
      </Row>
      <Row :gutter="18" style="margin-top: 20px">
        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 110px">子游戏名称:</span>
            <Select
              v-model="table.params.game_id"
              filterable
              placeholder="输入或选择所在游戏"
              clearable
              :disabled="table.params.query_type == 1"
            >
              <Option
                v-for="item in select.GameType_List"
                :value="item.value"
                :label="item.name"
                :key="item.value"
              >{{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 80px">统计时间:</span>
            <DatePicker
              type="daterange"
              v-model="table.params.dataTime"
              placeholder="统计时间"
              :options="dateOptions"
              style="width: 100%"
            ></DatePicker>
          </label>
        </Col>
      </Row>

      <Row>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">货币分类:</span>
            <Select
                v-model="table.params.currency_type"
                filterable
                placeholder="选择货币分类"
                clearable
            >
              <Option
                  v-for="item in currencyList"
                  :value="item.currency"
                  :label="item.name"
                  :key="item.currency"
              >
                {{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>
      </Row>
      <Row :gutter="18" style="margin-top: 20px">
        <Col span="4" style="display: flex; justify-content: space-between">
          <Button
            type="primary"
            style="margin-right: 10px"
            @click.native="searchData(true)"
            >查询</Button
          >
          <div>
            <Button
              type="primary"
              style="margin-right: 10px"
              @click.native="eleToExcel2({ fileName: `${table.params.dataTime[0].toLocaleDateString()}至${table.params.dataTime[1].toLocaleDateString()}` })"
              >导出excel</Button
            >
          </div>
          <Button type="primary" @click.native="everyDay()">每日数据</Button>
        </Col>
      </Row>
    </Card>
    <Table
      border
      :columns="table.columns"
      :data="table.data"
      style="margin-top: 12px"
      :max-height="tableMaxHeight"
      ref="tableRef"
    ></Table>
    <Page
      style="margin-top:10px;"
      :total="page.total"
      show-total
      :current="page.currentPage"
      :page-size-opts="page.pageSizes"
      :page-size="page.pageSize"
      show-sizer
      @on-page-size-change="pageSizeChange"
      @on-change="pageChange"
    ></Page>
  </div>
</template>

<script>
import MulReportHeader from './components/mul_report_header.vue'
import { TransTopReq } from '@/api/admin/risk'
import { mapState } from 'vuex'

export default {
  name: 'PackDataReport',
  components: { MulReportHeader },
  data() {
    return {
      modalShow: false,
      loading: false,
      TransTopReqTimer: null,
      timestamp: 0,
      all: {},
      tableMaxHeight: 0,
      select: {
        general_list: [],
        pack_list: [],
        GameType_List: JSON.parse(localStorage.getItem('gameList')),
        Query_Type: [
          { name: '代理', value: 1 },
          { name: '商户', value: 2 },
          { name: '子商户', value: 3 },
          { name: '玩家', value: 4 }
        ],
        Query_Type_day: [
          { name: '代理', value: 1 },
          { name: '商户', value: 2 },
          { name: '子商户', value: 3 }
        ],
        Day_Type: [
          { name: '商户', value: 2 },
          { name: '子商户', value: 3 }
        ]
      },
      //活动数据
      // GetZhuanPanActiveData
      table: {
        app_name: '',
        gp_name: '',
        params: {
          general_id: -1,
          platid: 0,
          // app_id: 0,
          app_id: '',
          pack_no: -1,
          // query_type: 1,
          query_type: '',
          game_id: -1,
          external_account: '',
          superior_name: '',
          dataTime: [
            new Date(
              this.getCurrentZeroDay().getTime() - 6 * 24 * 60 * 60 * 1000
            ),
            this.getCurrentZeroDay()
          ],
          currency_type: ''
        },
        data: [],
        columns: [
          this.getRenderColumn('account_id', '账号ID', '显示账号的ID'),
          this.getRenderColumn('account_name', '账号名称', '显示账号的名称'),
          this.getRenderColumn(
            'external_account',
            '三方账号',
            '筛选时间内,子商户新增转入人数'
          ),
          this.getRenderColumn(
            'account_type',
            '账号类型',
            '显示账号的类型，包括：代理，商户，子商户，玩家四种'
          ),
          this.getRenderColumn('superior_id', '上级ID', '显示上级账号的ID'),
          this.getRenderColumn('superior_name', '上级账号', '显示上级账号'),
          this.getRenderColumn(
            'game_name',
            '子游戏名称',
            '显示该条信息对应子游戏名称'
          ),
          this.getRenderColumn(
            'new_user_num',
            '新增人数',
            '筛选时间内，盘口新增注册人数（当类型为玩家的时候不显示人数）'
          ),
          // this.getRenderColumn(
          //   'pay_put_sum',
          //   '营收金额',
          //   '筛选时间内，盘口的营收金额'
          // ),
          // this.getRenderColumn(
          //   'revenue_rate',
          //   '营收比',
          //   '统计盘口（【转入金额总和】-【转出金额总和】）/【转入金额总和】'
          // ),
          this.getRenderColumn(
            'game_bet_user_num',
            '投注人数',
            '显示统计时间内的投注人数（当类型为玩家的时候不显示人数）'
          ),
          this.getRenderColumn(
              'currency_type',
              '货币分类',
              '显示统计时间内使用的货币'
          ),
          this.getRenderColumn(
            'bet_point',
            '投注金额',
            '显示统计时间内的投注金额总和'
          ),
          this.getRenderColumn(
            'win_point',
            '游戏盈亏',
            '该游戏筛选时间内的游戏盈亏金额；投注金额-返奖金额'
          ),
          this.getRenderColumn(
            'percent_point',
            '税收金额',
            '筛选时间范围内该游戏带来的税收金额'
          ),
          this.getRenderColumn(
            'kill_rate',
            '杀率统计(\%)',
            '统计时间游戏的杀率（【投注金额】-【返奖金额】）/【投注金额】',
            'auto'
          )
        ]
      },
      page: {
        total: 0,
        totalSum: 0,
        pageSize: 15,
        pageSizes: [15, 30, 45, 60],
        currentPage: 1
      },

      dayData: {
        params: {
          query_type: 1,
          general: -1,
          platid: 1,
          app_id: -1,
          pack_no: -1,
          user_id: '',
          superior_id: '',
          external_account: '',
          superior_name: '',
          dataTime: [
            new Date(
              this.getCurrentZeroDay().getTime() - 6 * 24 * 60 * 60 * 1000
            ),
            this.getCurrentZeroDay()
          ]
        },
        data: [],
        columns: [
          this.getRenderColumn(
            'i_date',
            '日期',
            '显示统计的日期，按天进行统计'
          ),
          this.getRenderColumn(
            'account_type',
            '账号类型',
            '显示账号的类型，包括：代理，商户，子商户两种'
          ),
          this.getRenderColumn(
            'account_name',
            '名称',
            '显示当前商户/子商户名称'
          ),
          this.getRenderColumn('game_name', '子游戏', '显示子游戏名称'),
          this.getRenderColumn(
            'new_user_num',
            '新增人数',
            '筛选时间内，盘口新增注册人数'
          ),
          // this.getRenderColumn(
          //   'pay_put_sum',
          //   '营收金额',
          //   '筛选时间内，盘口的营收金额'
          // ),
          // this.getRenderColumn(
          //   'revenue_rate',
          //   '营收比',
          //   '(【转入金额总和】-【转出金额总和】）/【转入金额总和】*100%'
          // ),
          this.getRenderColumn(
            'game_bet_user_num',
            '投注人数',
            '显示统计时间内，该子游戏下的投注人数总和'
          ),
          this.getRenderColumn(
            'bet_point',
            '投注金额',
            '统计时间内，该子游戏所产生的投注金额总和'
          ),
          this.getRenderColumn(
            'win_point',
            '游戏盈亏',
            '筛选时间内，筛选的子游戏中的（投注金额-返奖金额）'
          ),
          this.getRenderColumn(
            'percent_point',
            '游戏税收',
            '统计时间内，该子游戏产生的税收金额'
          ),
          this.getRenderColumn(
            'kill_rate',
            '杀率统计(%)',
            '统计时间游戏的杀率',
            'auto'
          )
        ]
      }
    }
  },
  computed: {
    ...mapState({
      currencyList: state => state.app.globalCurrencyList
    }),
  },
  methods: {
    getRenderColumn(key, title, tip, width = 90) {
      return {
        key,
        align: 'center',
        title,
        resizable: true,
        renderHeader: h => this.renderHeader(h, title, tip),
        render: (h, params) => this.renderCol(h, params)
      }
    },
    //查询数据
    searchData(reset) {
      if (reset) {
        this.page.currentPage = 1
      }
      let stime = this.getSecond(this.table.params.dataTime[0])
      let etime = this.getSecond(this.table.params.dataTime[1], false)
      this.timestamp = new Date().getTime()
      let params = this.getTransTopParams('GetNewPlatfromData', {
        stime,
        etime,
        page: this.page.currentPage,
        limit: this.page.pageSize,
        query_type: this.table.params.query_type
          ? Number(this.table.params.query_type)
          : 1,
        general: this.anyToNumber(this.table.params.general_id, -1),
        pack_no: this.anyToNumber(this.table.params.pack_no, -1),
        user_id: Number(this.table.params.user_id),
        superior_id: this.table.params.superior_id
          ? Number(this.table.params.superior_id)
          : -1,
        external_account: this.table.params.external_account,
        superior_name: this.table.params.superior_name,
        game_id: this.anyToNumber(this.table.params.game_id, -1),
        currency_type: this.table.params.currency_type
      })
      this.table.data = []
      let params1 = this.copyData(params)

      params1.param._func = 'GetPlatformSum'

      if (!this.table.params.app_id || this.table.params.app_id == -1) {
        const reqList = []
        const appList = this.getAppList()

        appList.forEach(item => {
          params1.param._param.app_id = item.appid
          reqList.push(TransTopReq(params1))
        })

        Promise.all(reqList).then(values => {
          let lists = []
          values.forEach(item => {
            if (item._param.list) {
              lists = lists.concat(item._param.list)
            }
          })
          this.table.data = lists
        })
      } else {
        params1.param._param.app_id = this.table.params.app_id
        TransTopReq(params1).then(res1 => {
          this.table.data = res1._param.list
          this.page.total = res1._param.total
        })
      }
    },
    renderCol(h, params) {
      let key = params.column.key
      let row = params.row

      if (key == 'account_type') {
        const data = this.select.Query_Type.find(
          item => item.value == row.account_type
        )
        return h('span', data.name)
      }

      if (
        key == 'external_account' ||
        key == 'superior_name' ||
        key == 'game_name'
      ) {
        return this.renderNilData(h, params)
      }
      if (
        key == 'pay_put_sum' ||
        key == 'bet_point' ||
        key == 'win_point' ||
        key == 'percent_point'
      ) {
        return this.renderMoney(h, params)
      }
      // 账号类型处理
      if (key == 'account_type') {
        const types = this.select.Query_Type.filter(
          item => item.value == row.account_type
        )
        return h('span', types[0].name)
      }

      if (['kill_rate', 'revenue_rate'].includes(key)) {
        return h('span', row[key]/100 + '%')
      }
      return h('span', row[key])
    },
    getTableLength() {
      return Math.max(this.table.data.length - 1, 1)
    },
    getAppList() {
      return this.app_list.filter(el => this.table.params.platid == el.platform)
    },
    getAppGenList() {
      if (!this.table.params.app_id) return
      let params = this.getTransTopParams('GetAppGeneralList', {
        app_id: this.table.params.app_id,
        platid: this.table.params.platid,
        stime: this.getSecond(this.table.params.dataTime[0]),
        etime: this.getSecond(this.table.params.dataTime[1], false),
        page: 1,
        limit: 100,
        sort: 0,
        general: -1,
        pack_no: -1
      })
      this.select.general_list = []
      this.select.pack_list = []
      this.table.params.general_id = -1
      this.table.params.pack_no = -1
      TransTopReq(params).then(res => {
        this.select.general_list = res._param.general_list
        this.table.params.general_id = ''
        let params1 = this.copyData(params)
        params1.param._func = 'GetPackList'
        TransTopReq(params1).then(res => {
          this.select.pack_list = res._param.pack_list || []
        })
      })
    },
    updateGeneral() {
      this.table.params.pack_no = -1
    },
    getPackList() {
      return this.select.pack_list.filter(
        el => el.general == this.table.params.general_id
      )
    },
    //透传接口请求参数 请求方法 请求参数
    getTransTopParams(func, param) {
      return {
        mod: 'root',
        platid: this.table.params.platid,
        app_id: param.app_id,
        app_name: param.app_name,
        timestamp: param.timestamp,
        param: {
          _mod: 'manager',
          _func: func,
          _param: {
            ...param
          }
        }
      }
    },
    updatePlat() {
      this.table.params.app_id = this.getAppList()[0]['appid']
      this.getAppGenList()
    },
    initFunc() {
      this.table.params.platid = this.getinitPlatId()
      // this.table.params.app_id = this.app_list.find(
      //   el => el.platform == this.table.params.platid
      // )['appid']
      this.getAppGenList()
    },
    pageChange(page) {
      this.page.currentPage = page
      this.searchData()
    },
    pageSizeChange(size) {
      this.page.pageSize = size
      this.searchData()
    },
    // 每日数据
    everyDay() {
      this.modalShow = true
      this.updatePlatDay()
      this.getEveryDayData()
    },
    // 获取每日列表数据
    getEveryDayData() {
      const params = this.getTransTopParams('GetDayPlatformSum', {
        platid: this.dayData.params.platid,
        app_id: this.dayData.params.app_id,
        timestamp: new Date().getTime(),
        stime: this.getSecond(this.dayData.params.dataTime[0]),
        etime: this.getSecond(this.dayData.params.dataTime[1], false),
        page: 1,
        limit: 10000,
        general: this.dayData.params.general,
        pack_no: this.dayData.params.pack_no,
        game_id: this.dayData.params.game_id,
        query_type: this.dayData.params.query_type
      })
      TransTopReq(params).then(res => {
        if (res._param.list) {
          this.dayData.data = res._param.list
        }
      })
    },
    getAppListDay() {
      return this.app_list.filter(
        el => this.dayData.params.platid == el.platform
      )
    },
    updatePlatDay() {
      this.dayData.params.app_id = this.getAppListDay()[0]['appid']
    },
    updateGeneralDay() {
      this.dayData.params.pack_no = -1
    },
    getPackListDay() {
      return this.select.pack_list.filter(
        el => el.general == this.dayData.params.general
      )
    },
    searchDataDay() {
      this.getEveryDayData()
    },
    queryTypeChange(value) {
      if (value == 1) {
        this.resetData()
        return
      }
      if (value == 2) {
        this.table.params.pack_no = -1
        this.table.params.user_id = ''
        this.table.params.external_account = ''
        return
      }
      if (value == 3) {
        this.table.params.user_id = ''
        this.table.params.external_account = ''
        return
      }
    }
  },
  activated() {
    this.initFunc()
    this.searchData()
  },
  mounted() {
    this.tableMaxHeight = window.document.body.clientHeight - 360
  }
}
</script>

<style scoped lang="less"></style>
